import Header from "../../components/Header/Header";
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import styles from "./OurTeam.module.css";
import { ourAdvisors } from "../../data/people";
import AdvisorCard from "../../components/AdvisorCard/AdvisorCard";
import Footer from "../../components/Footer/Footer";
import ColorBanner from "../../components/ColorBanner/ColorBanner";

import usePageTitle from "../../hooks/usePageTitle";
import { foregroundConfig, backgroundConfig } from "../../data/particles";
import Particles from "@tsparticles/react";
import useWindowSize from "../../hooks/useWindowSize";
import HorizontalLeaderCardScroller from "../../components/HorizontalLeaderCardScroller/HorizontalLeaderCardScroller";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";

function OurTeam() {
    const windowSize = useWindowSize();
    const [quoteCardContentRef, , fadedClassName] =
        useIntersectionObserver(0.2);

    usePageTitle("Our Team");

    return (
        <div id={styles.leadership}>
            <Header />
            <main id={styles.main}>
                <div id={styles.hero_particles_container}>
                    <Particles
                        key={windowSize.width}
                        id={styles.background_particles}
                        className={styles.hero_particles}
                        options={backgroundConfig}
                    />
                    <Particles
                        key={windowSize.width + 1}
                        id={styles.foreground_particles}
                        className={styles.hero_particles}
                        options={foregroundConfig}
                    />
                </div>
                <HorizontalLeaderCardScroller />
                <section
                    className={styles.advisors_section}
                    id={styles.board_section}
                >
                    <SectionHeading
                        heading={"Board of directors"}
                    ></SectionHeading>
                    <div className={styles.advisors_container}>
                        {ourAdvisors
                            .filter((a) => a.role === "Board member")
                            .map((a) => (
                                <AdvisorCard key={a.name} {...a} />
                            ))}
                    </div>
                </section>
                <section className={styles.advisors_section}>
                    <SectionHeading heading={"Advisors"}></SectionHeading>
                    <div className={styles.advisors_container}>
                        {ourAdvisors
                            .filter((a) => a.role === "Advisor")
                            .map((a) => (
                                <AdvisorCard key={a.name} {...a} />
                            ))}
                    </div>
                </section>
                <section id={styles.quote_section}>
                    <div
                        className={[styles.quote_card, "big-dark-card"].join(
                            " "
                        )}
                    >
                        <div
                            id={styles.quote_card_content}
                            ref={quoteCardContentRef}
                            className={fadedClassName}
                        >
                            <div className={styles.quote_text}>
                                <img
                                    className={[
                                        styles.quotation_mark_image,
                                        styles.open_quote,
                                    ].join(" ")}
                                    src="/images/open-quote.svg"
                                    alt="Open quote"
                                />
                                Let’s embrace a future where technology not only
                                advances our capabilities but also supports our
                                mental wellness.
                                <img
                                    className={[
                                        styles.quotation_mark_image,
                                        styles.close_quote,
                                    ].join(" ")}
                                    src="/images/close-quote.svg"
                                    alt="Close quote"
                                />
                            </div>
                            <div className={styles.quote_source}>
                                <img
                                    src="/images/headshots/small/rob-godfrey-headshot-small.png"
                                    alt=""
                                    className={styles.quote_source_image}
                                />
                                <div className={styles.quote_source_text}>
                                    <div className={styles.quote_source_name}>
                                        Rob Godfrey
                                    </div>
                                    <div className={styles.quote_source_title}>
                                        President & CEO
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <ColorBanner />
            </main>
            <Footer />
        </div>
    );
}

export default OurTeam;
